var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.user)?_c('div',{staticClass:"nav-profile"},[_c('DsAvatar',{attrs:{"type":"user","image-url":_vm.user.emailSignatureURL,"name":_vm.user.givenName,"size":29}}),_c('div',{staticClass:"description"},[_c('h6',{staticClass:"name"},[_vm._v(" "+_vm._s(_vm.$t('nav.profile.hello', { name: _vm.user.givenName }))+" ")])])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }